export const Browsers = {
  rO: "Chrome",
  eO: "Edge",
  oO: "Opera",
  Bg: "Safari",
  OO: "Firefox",
  Sg: "ChatGPTBrowser",
};
export const OperatingSystems = {
  Dg: "Android",
  co: "iOS",
  Pg: "Mac",
  kg: "Windows",
};
